import { Thread } from "../../../../shared/models/thread";
import { Post } from "../../../../shared/models/post";

export type StepperDirection = "previous" | "next" | "jumpToFirst";

export const NEXT: StepperDirection = "next";
export const PREVIOUS: StepperDirection = "previous";
export const JUMPTOFIRST: StepperDirection = "jumpToFirst";

export interface StepperServiceType {
  steps: string[];

  /** direction of the action , could be previous or next */
  direction: StepperDirection;
  stepIndex: number;
  statusDescription: string;
  statusResponsible: string;
  numberOfResponsibleLeft: number;

  /** Variable for checking if next status button is diabled */
  nextStatusDisabled: boolean;

  /** Variable for checking if previous status button is diabled */
  previousStatusDisabled: boolean;
  /** Get a list with all values of the stepper */
  getSteps(): void;

  /** Get the step index for the current status */
  getStepIndex(thread: Thread): void;

  /** Get the status description for the DB client */
  getStatusDescription(thread: Thread): void;

  /** Get the status responsible for the DB client */
  getStatusResponsible(thread: Thread): void;

  /** Get the number of responsibles for the DB client */
  getNumberOfResponsibleLeft(): void;

  /** Get the modals text depending on clients and the action involved (next/previous) */
  textWithVariable(text: string, status: string): string;

  /** Enable/diable next/previous status buttons */
  isStepDisabled(status: string, solutions?: Post[]): void;

  /** Does the current user have the permission to change the staus of the thread */
  hasChangeStatusPermission(direction: string): boolean;

  /** Set a new due date and change status based on direction - maquet cardio only */
  setDueDate(): void;
}
